export default __webpack_public_path__ + "static/media/1.b048b1bd.jpg";